<template>
  <div>
    <questionTitle
      :question_kind="
        question_item.question_kind && question_item.question_kind.id
      "
      ref="questionTitle"
      @selectedTitleText="selectedTitleText"
      @getTitleID="getTitleID"
    />
    <div class="float-right mt-2">
      <b-button
        @click="save"
        class="text-center"
        variant="success"
        :disabled="isloading"
      >
        <div v-if="!isloading">
          {{ $lang.submitButton }}
          <span key="fa-check"><i class="fa fa-check"></i></span>
        </div>
        <div v-if="isloading">
          <b-spinner small></b-spinner>
          <span> {{ $lang.search.loading_send }}</span>
        </div>
      </b-button>
      <b-button @click="closeModal" class="ml-2" size="md" variant="danger">
        <i class="fa fa-ban"></i>
        {{ $lang.cancelButton }}
      </b-button>
    </div>
  </div>
</template>

<script>
import questionTitle from "@/components/azmoon/title/questionTitle";
export default {
  components: {
    questionTitle,
  },
  props: {
    isClone: {
      type: Boolean,
      default: false,
    },
    question_item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isModal: this.isClone,
      title_description: null,
      isloading: false,
    };
  },
  methods: {
    selectedTitleText(item) {
      this.title_description = item;
    },
    getTitleID(item) {
      this.title_id = item.id;
    },
    closeModal() {
      this.$emit("closeModal");
    },
    async save() {
      try {
        this.isloading = true;
        const { id } = this.question_item;
        const url =
          this.$config.api_url +
          this.$config.azmoon.question_id_clone.replace("{0}", id);
        let payload = {};

        if (this.title_id) {
          payload.title_id = this.title_id;
        } else {
          payload.title_description = this.title_description;
        }
        const response = await this.$httpService.post(url, payload);
        this.$emit("getDataSeach");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isloading = false;
      }
    },
  },
  watch: {
    isClone(newVal) {
      this.isModal = newVal;
    },
  },
};
</script>

<style>
</style>
